import React, { useState } from "react"
import styled from "styled-components"
import { doLogout } from "../../../actions/loginDataActionCreator"
import { Button } from "../../../components/parts/buttons/button"
import { Headline } from "../../../components/parts/headline/headline"
import { Loading } from "../../../components/parts/loading"
import store from "../../../config/configureStore"
import { JSONRPCErrorCatch } from "../../../error/error"
import { NotificationActionDispatcher } from "../../../libs/notifications"
import { JSONRPCClientBuilder } from "../../../request/JSONRPCClientBuilder"
import { UserRPC } from "../../../rpcs/dist/UserRPC"
import Color from "../../../style/enum/color"
import { RouteComponentProps, withRouter } from "react-router-dom"

type IProps = RouteComponentProps

export const Other = withRouter((props: IProps) => {
  const [checkbox, setCheckbox] = useState<boolean>(false)
  const [unsubscribeProcessing, setUnsubscribeProcessing] = useState<boolean>(
    false,
  )

  const onChange = () => setCheckbox(!checkbox)
  const unsubscribe = async () => {
    setUnsubscribeProcessing(true)
    const userRPC = JSONRPCClientBuilder.build(UserRPC)
    const res = await userRPC.unsubscribe().catch(JSONRPCErrorCatch)
    if (res !== -1) {
      store.dispatch(doLogout())
      NotificationActionDispatcher.SuccessNotification(
        "退会が完了しました。ご利用いただきありがとうございました。",
      )
      props.history.push("/")
    }
    setUnsubscribeProcessing(false)
  }

  if (unsubscribeProcessing) {
    return <Loading text={"退会処理中"} verticalPadding={"150px"} />
  }

  return (
    <div>
      <Headline>ChatCastを退会する</Headline>
      <Caution>
        <ul>
          <li>アカウントに紐づく全てのデータが閲覧見れなくなります</li>
          <li>アカウント情報も失われます</li>
          <li>一度退会すると、元に戻すことはできません</li>
        </ul>
      </Caution>
      <FlexCenter>
        <CheckboxWrapper>
          <label>
            <input type="checkbox" checked={checkbox} onChange={onChange} />{" "}
            退会に関する注意事項に同意する
          </label>
        </CheckboxWrapper>
        {(() => {
          if (checkbox) {
            return (
              <Button
                backgroundColor={Color.WHITE}
                color={Color.RED}
                borderColor={Color.RED}
                onClick={unsubscribe}
              >
                退会する
              </Button>
            )
          } else {
            return (
              <Button
                backgroundColor={Color.WHITE}
                color={Color.UNSUBSCRIBE_NOT_CHECK_RED}
                borderColor={Color.UNSUBSCRIBE_NOT_CHECK_RED}
                disabled={true}
              >
                退会する
              </Button>
            )
          }
        })()}
      </FlexCenter>
    </div>
  )
})

const Caution = styled.div`
  margin: 16px 0;
  color: ${Color.DIMGRAY};
`

const FlexCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CheckboxWrapper = styled.div`
  margin: 16px 0;
  > label {
    display: flex;
    align-items: center;
    color: ${Color.BLACK};
    font-size: 0.9rem;
    > input {
      margin-right: 8px;
    }
  }
`
